import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as api from '../api/api';
import { useAuth } from '../context/AuthContext';
import { ROLES } from '../config/rbac';
import { pickErrorMessage } from '../lib/apiHelpers';
import { toastSuccess } from '../lib/toast';
import { PageHeader, Card, CardBody, ErrorBanner, BackLink } from '../components/PageChrome';
import { MetadataEditor, cleanMetadata } from '../components/MetadataEditor';

export default function CouponGenerate() {
  const { hasRole } = useAuth();
  const isSuper = hasRole(ROLES.SUPER_ADMIN);
  const navigate = useNavigate();
  const [count, setCount] = useState(10);
  const [brandId, setBrandId] = useState('');
  const [brands, setBrands] = useState([]);
  const [metadata, setMetadata] = useState([{ label: 'Product', value: '' }]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!isSuper) return;
    let cancelled = false;
    (async () => {
      try {
        const data = await api.listBrands({ limit: 100 });
        if (!cancelled) {
          setBrands(data?.items || []);
          if (data?.items?.[0]) setBrandId(data.items[0].id);
        }
      } catch {
        /* optional for super */
      }
    })();
    return () => { cancelled = true; };
  }, [isSuper]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    const cleaned = cleanMetadata(metadata);
    setBusy(true);
    try {
      const body = {
        count: Number(count) || 1,
        metadata: cleaned,
      };
      if (isSuper && brandId) body.brandId = brandId;
      const res = await api.generateCoupons(body);
      toastSuccess(`Generated ${res.count ?? res.created?.length ?? count} coupon(s).`);
      setTimeout(() => navigate('/coupons'), 800);
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <BackLink to="/coupons">Coupons</BackLink>
      <PageHeader title="Generate coupons" subtitle="Create new authenticity codes from your quota" />
      <ErrorBanner message={error} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit} className="mw-form">
            {isSuper ? (
              <div className="mb-3">
                <label htmlFor="brandId" className="form-label">Brand</label>
                <select id="brandId" className="form-select" value={brandId} onChange={(e) => setBrandId(e.target.value)} required>
                  {brands.map((b) => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
              </div>
            ) : null}
            <div className="mb-3">
              <label htmlFor="count" className="form-label">How many codes?</label>
              <input id="count" type="number" min={1} max={500} className="form-control" value={count} onChange={(e) => setCount(e.target.value)} required />
            </div>
            <MetadataEditor items={metadata} onChange={setMetadata} />
            <div className="d-flex gap-2 mt-4">
              <button type="submit" className="btn btn-primary" disabled={busy}>{busy ? 'Generating…' : 'Generate'}</button>
              <Link to="/coupons" className="btn btn-outline-secondary">Cancel</Link>
            </div>
          </form>
        </CardBody>
      </Card>
    </>
  );
}
